import { isEmpty, find } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Selector from '../../Common/Selector';
import Tag from '../../Tags/Tag';
import { TagType } from 'types/types';

export interface TicketFilterByTagProps {
  className?: string;
  name?: string;
  dark?: boolean;
  onChange: (event: CustomEvent) => void;
  tags: TagType[] | null;
  value: string[] | null;
}

const { CLASS_NAME_PREFIX } = Selector;

const PLACEHOLDER = 'Все теги';

const StyledTag = styled(Tag)`
  color: inherit;
  font-size: 14px;
`;

class TicketFilterByTag extends React.PureComponent<TicketFilterByTagProps> {
  el: any = null;

  static defaultProps = {
    className: '',
    name: '',
    dark: false,
    tags: null,
    value: null,
  };

  static getMultiValueContainer = ({ data, innerProps, children }) => {
    const { backgroundColor, textColor: color } = data;

    return (
      <div
        {...innerProps}
        style={{
          backgroundColor,
          color,
        }}
      >
        {children}
      </div>
    );
  };

  static getMultiValueLabel({ data, innerProps }) {
    const { label } = data;

    return (
      <div {...innerProps}>
        <StyledTag tag={label} />
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;

    const formatedValue = Array.isArray(value) ? value.map(v => v.value) : null;
    this.el.name = name;
    this.el.value = formatedValue;

    const event = new CustomEvent('change', {
      bubbles: true,
    });

    this.el.dispatchEvent(event);
    onChange(event);
  }

  handleRef(ref) {
    this.el = ReactDOM.findDOMNode(ref);
  }

  render() {
    const { tags, value, dark, ...props } = this.props;

    if (isEmpty(tags)) {
      return null;
    }

    let formatedValue: (TagType | undefined)[] | null = null;
    if (Array.isArray(value)) {
      formatedValue = value.map(v => find(tags, { value: v }));
    }

    return (
      <StyledSelector
        {...props}
        components={{
          MultiValueContainer: TicketFilterByTag.getMultiValueContainer,
          MultiValueLabel: TicketFilterByTag.getMultiValueLabel,
          ClearIndicator: () => null,
        }}
        isMulti
        dark={dark}
        isSearchable
        onChange={this.handleChange}
        options={tags}
        placeholder={PLACEHOLDER}
        ref={this.handleRef}
        value={formatedValue}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        filterOption={(option, rawInput) => {
          if (!option.data?.active) return false;
          if (!rawInput) return true;

          const label = (option.label ?? '').toLowerCase();
          return label.includes(rawInput.toLowerCase());
        }}
      >
        {({ label }) => <StyledTag tag={label} />}
      </StyledSelector>
    );
  }
}

const StyledSelector = styled(Selector)`
  ${({ dark }) =>
    dark &&
    `
    border: 1px solid #e6e9ee;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 3px;

    .${CLASS_NAME_PREFIX}__multi-value {
      background: #f5f3f2;
      border: none;
    }

    ${CLASS_NAME_PREFIX}__placeholder {
      color: #919499;
    }
  `}
`;

export default TicketFilterByTag;
